import { render, staticRenderFns } from "./case-update-import-config.vue?vue&type=template&id=24a798a8&scoped=true"
import script from "./case-update-import-config.vue?vue&type=script&lang=ts"
export * from "./case-update-import-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a798a8",
  null
  
)

export default component.exports